import 'reflect-metadata';
import { Expose, plainToInstance, instanceToPlain } from 'class-transformer';

export class Company {
  name: string;

  @Expose({ name: 'support_email' })
  supportEmail: string;

  email: string;
  phone: string;
  logo: string;

  @Expose({ name: 'logo_small' })
  logoSmall?: string;

  constructor(
    name: string,
    supportEmail: string,
    email: string,
    phone: string,
    logo: string,
    logoSmall?: string
  ) {
    this.name = name;
    this.supportEmail = supportEmail;
    this.email = email;
    this.phone = phone;
    this.logo = logo;
    this.logoSmall = logoSmall;
  }

  static fromJson(json: Record<string, any>): Company {
    return plainToInstance(Company, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}
